export default __webpack_public_path__ + "static/media/pvilla4-3.d3531800.webp";